const validateUrl = (url) => {
    try {
        const u = new URL(url);
        return u;
    } catch (err) {
        return false;
    }
};

export const ajaxCall = async (isbn = '', container, actionName, parameters = '') => {
    if (!universityPressThemeSettings.wordpressAjaxUrl || !universityPressThemeSettings.ajaxNonce) {
        return;
    }

    const ajaxUrl = validateUrl(universityPressThemeSettings.wordpressAjaxUrl);
    if (!ajaxUrl) {
        return;
    }

    ajaxUrl.searchParams.set("action", actionName);
    ajaxUrl.searchParams.set("nonce", universityPressThemeSettings.ajaxNonce);

    if (isbn) {
        ajaxUrl.searchParams.set("isbn", isbn);
    }

    if (parameters) {
        ajaxUrl.searchParams.set("parameters", parameters);
    }

    const response = await fetch(ajaxUrl);
    if (!response.ok) {
        return;
    }

    Object.assign(container, { innerHTML: await response.text() });
};
